require('../../pages/registration/accounts/components/basic_or_coaching/index');
